.gallery {
  display: flex;
  flex-direction: column;
}

.panel {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.panel:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

/* The mockup's `.grid`: 240px minimum columns, 16px apart. */
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: var(--space-4);
  margin: 0;
  padding: 0;
  list-style: none;
}

.more {
  align-self: flex-start;
}
